<script setup>
</script>

<template>
  <header class="inner">
    <div class="head-back">
      <a
        href="#"
        onclick="history.back(); return false;"
      >戻る</a>
    </div>
    <p>ライブカメラ</p>
  </header>
</template>

<style scoped>
.inner {
  align-items: center;
  background: #0a358b;
  border-bottom: 2px solid #0a358b;
  display: flex;
  padding: 5px 10px;
  width: 100%;
}
.head-back a {
  background-color: #f9f8f2;
  border-radius: 0 3px 3px 0;
  color: #493e01;
  display: block;
  font-size: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 35px;
  text-decoration: none;
}
.head-back:before {
  background-color: #f9f8f2;
  clip-path: polygon(0 50%, 100% 0, 100% 100%);
  content: "";
  display: block;
  height: 30px;
  width: 10px;
}
.head-back {
  display: flex;
}
.inner p {
  color: #fff;
  font-family: ヒラギノ角ゴ ProN W3, HiraKakuProN-W3;
  font-size: 16px;
  text-align: center;
  width: 100%;
  margin-right: 40px;
}
</style>
